module.exports = __webpack_public_path__ + "static/img/starCharge.f57f2369.jpg";